import PortalAdminDashboard from "./PortalAdminDashboard";

export default PortalAdminDashboard;
